import React, { useEffect, useState } from 'react'
import { Logo } from '../components/Logo'
import { useDispatch, useSelector } from 'react-redux';
import { loadingAction, log } from '../store/actions/login.actions';
import websapp from '../assets/LOGO_WebSal.png'
import 'animate.css';
import googleplay from '../assets/googleplay.png'
import appstore from '../assets/appstore.png'
import { Link, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2'
import { Loading } from '../components/Loading';
import eye from '../assets/eye-outline.svg'
import eyeOff from '../assets/eye-off-outline.svg'




export const Login = () => {

  let navigate = useNavigate();

  const [pe, setPe] = useState("")
  const [px, setPx] = useState("")
   
  

  const dispatch = useDispatch()

  const [loading, setLoading] = useState(false)

  const sign =() => {

    if(pe === 641638 || pe === '641638'){
      return console.log(`usuario ${pe} bloqueado`)
    }

    if(pe === '' || px === '' ){
      Swal.fire({
        title: 'Completa todos los campos',
        text: 'Intentalo otra vez',
        confirmButtonColor:'#2ec1db',
        
      })
        return
    }
    
    //  console.log('pasaporaca')
    localStorage.removeItem('empresaId')

    setLoading(true)

    dispatch(log(pe,px,setLoading,navigate))
    
    recuerdame()


    
  }

  const [remembUser, setRemembUser] = useState(false)


        useEffect(() => {
          logrecuerdame()
        }, [])

  const recuerdame =  () => {
        if(remembUser){
             localStorage.removeItem('remember')
             localStorage.setItem('remember', pe)
        }
        if(!remembUser){
          localStorage.removeItem('remember')
            
        }
  }

  const logrecuerdame =  () => {
        const name =  localStorage.getItem('remember')
        setPe(name)
        if(name){
            setRemembUser(true)
        }
        
  }

  const pressEnter = (e) => {
    if(e.key === 'Enter'){
      sign()
    }

  }

  const [mostrar, setmostrar] = useState('password')


  const ver = () => {

    if(mostrar === 'text'){

        setmostrar('password')

        return
    }

    if(mostrar === 'password'){

        setmostrar('text')
        
        return
    }

  }



  return (
    

    
    <div className={loading ? 'nada' : 'container'} >


   
   

        {
          loading ? <div className='marginTopLoading' ><Loading/>
          </div>  :
          <>
            <div className='containerLogin animate__animated animate__fadeIn'>

                      <div className='contenedorLogo'>

                        <a href='https://home.websal.com' target='_blank' ><Logo/></a>
                            

                      </div>

                      <div className='iniciar' >
                            <p>Inicia Sesión en <span>  WebSal</span></p>
                      </div> 
                    

                      

                    <div className='contenedorInput' >

                                  <label > Código contrato </label>
                                  <input type='text' value={pe} onChange={e => setPe(e.target.value) } />
                                  <div className='recuerdameContainer' >
                                    <p>Recuerdame</p>
                                    <input className='inputCheck' onKeyPress={pressEnter} type="checkbox" checked={remembUser} onChange={ () => setRemembUser(!remembUser)} />

                                  </div>
                                  
                                        

                                  <label> Contraseña </label>
                                  <div className='contenedorClaveOjo'>

                                      <input type={mostrar} onKeyPress={pressEnter} value={px} onChange={e => setPx(e.target.value) } />
                                      
                                      <button className='mostrarBtnLogin' onClick={() => ver() } >
                                            <img className='ver' src={ mostrar === 'password' ? eye : eyeOff } alt='ver' />
                                      </button>


                                  </div>

                                  
                                  <button type='button' className='ingresar' onClick={ sign} >
                                    <p>Ingresar</p> 
                                  </button> 
                                  
                        

                    </div>


                    <div className='contenedorOptionsLogin' >

                      



                                  <button onClick={ () => navigate('/RecuperarClave') } className='recuperarClave marginTop' >
                                    <p className='textoRecuperarClave' > Recuperar Contraseña </p> 
                                  </button>

                                  <button onClick={ () => navigate('/PrimeraVez') } className='recuperarClave' >
                                    <p className='textoPrimeraVez' >¿Primera vez en WebSal? <span>Ingresa Aqui</span> </p> 
                                  </button>

                                  <button onClick={ () => navigate('/representante') } className='recuperarClave' >
                                    <p className='textoPrimeraVez representanteEmpresa' > Ingresar como representante de empresa  </p> 
                                  </button>



                    </div>






              </div>

              <div className='contenedorAppLogin' >

        

                        <div className='contenedorWebApp' > 
                             <a href='https://home.websal.com' target='_blank' ><img src={websapp} width='160' /> </a>

                        </div>


                          <p className='primer' >Descargar la App de Autoconsulta </p>
                          <p className='frase' >Accede a tus datos laborales donde y cuando quieras</p>
                        

                          <p >Encuentrala en:</p>
                        <div className='contendorAppstores' >
                          
                              <a href='https://play.google.com/store/apps/details?id=com.appwebsal' target='_blank'  >
                                <img src={googleplay} />

                              </a>
                          
                  

                          
                          <a href='https://apps.apple.com/cl/app/websal/id1627284767' target='_blank' >
                          <img className='appstore' src={appstore}  />


                          </a>

                          
                        </div>



  
                
          
            
          

            </div>

          

          
          </>
        }


          



    </div>


  )
}
